/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { getUserInfo } from "../../../../../utils/user.util";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  let userInfo = getUserInfo();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${
          !hasSubmenu && "menu-item-active"
        } menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      {userInfo?.admin?.role === "superadmin" ? (
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
          {/*begin::1 Dashboard*/}
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/dashboard",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link" to="/dashboard">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Dashboard</span>
            </NavLink>
          </li>

          {/*end::1 Engage*/}
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/roles",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/roles">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Roles</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/* Inputs */}
                {/*begin::2 Level*/}
                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/roles/superAdmin",
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link" to="/roles/superAdmin">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Super Admin</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/roles/admin",
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link" to="/roles/admin">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Admin</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/roles/user",
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link" to="/roles/user">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">User</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/*end::1 Engage*/}
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/amenities",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/amenities">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Amenities</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/* Inputs */}
                {/*begin::2 Level*/}
                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/amenities/distinctive",
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link" to="/amenities/distinctive">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Distinctive Amenities</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/amenities/standard",
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link" to="/amenities/standard">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Standard Amenities</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/*end::1 Engage*/}
          {/* <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/contactUs",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/contactUs">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Contact Us</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/contactUs/contactUsAdmin",
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link" to="/contactUs/contactUsAdmin">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Contact Us</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/contactUs/contactUsGeneral",
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link"
                    to="/contactUs/contactUsGeneral"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">ContactUs General</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li> */}

          <li
            className={`menu-item ${getMenuItemActive("/contactUs/contactUsGeneral", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/contactUs/contactUsGeneral">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Contact Us</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/properties", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/properties">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Properties</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/faqs", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/faqs">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">FAQs</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/aboutus", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/aboutus">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">About Us</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/bannerimage", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/bannerimage">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Banner Image</span>
            </NavLink>
          </li>
          <li
            className={`menu-item ${getMenuItemActive("/companydetails", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/companydetails">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Company Details</span>
            </NavLink>
          </li>
          {/* <li
            className={`menu-item ${getMenuItemActive("/logo", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/logo">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Logo</span>
            </NavLink>
          </li> */}
          <li
            className={`menu-item ${getMenuItemActive("/cms", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/cms">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Menu</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/socialmedia", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/socialmedia">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Social Media</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/marketingbanner", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/marketingbanner">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Marketing Banner</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/howitworks", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/howitworks">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">How It Works</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/ourtrustedpartners", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/ourtrustedpartners">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Our Trusted Partners</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/knowMore", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/knowMore">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Know More</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/populardestination", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/populardestination">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Popular Destination</span>
            </NavLink>
          </li>
          <li
            className={`menu-item ${getMenuItemActive("/enjoythereturns", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/enjoythereturns">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Enjoy The Returns</span>
            </NavLink>
          </li>

        </ul>
      ) : (
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
          {/*begin::1 Dashboard*/}
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/dashboard",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link" to="/dashboard">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Dashboard</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive(
              "/contactUsAdmin",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/contactUsAdmin">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">ContactUs</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/properties", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/properties">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">Properties</span>
            </NavLink>
          </li>
        </ul>
      )}
      {/* end::Menu Nav */}
    </>
  );
}
